import { styled } from 'styled-components';
import { Font, FontSize } from '@app/themes/Fonts';

const TypographyBase = styled.div<{
  size: keyof typeof FontSize;
  color?: string;
  weight?: string;
  as?: React.ElementType;
}>`
  font-family: ${Font.PrimaryFontFamily}, sans-serif;
  font-size: ${({ size }) => FontSize[size]};
  color: ${({ color }) => color || 'inherit'};
  font-weight: ${({ weight, as }) => weight || (as && /^h[1-6]$/.test(String(as)) ? 'bold' : 'normal')};
`;

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  size?: keyof typeof FontSize;
  color?: string;
  weight?: string;
  as?: React.ElementType;
  children: React.ReactNode;
}

export const Typography: React.FC<TypographyProps> = ({
  size = 'default',
  color,
  weight,
  as = 'p',
  children,
  ...props
}) => {
  return (
    <TypographyBase as={as} size={size} color={color} weight={weight} {...props}>
      {children}
    </TypographyBase>
  );
};
